import { IFormState } from '../types/calculator';
import { useEffect, useRef } from 'react';
import { equals } from 'ramda';

export const usePreviousValuesEqualCurrent = (currentValues: IFormState): boolean => {
  const prevValuesRef = useRef<IFormState | null>(null);
  const isEqual = equals(currentValues, prevValuesRef.current);

  useEffect(() => {
    prevValuesRef.current = currentValues;
  }, [currentValues]);

  return isEqual;
};
